import { Box, Card, CardContent, TextField } from '@mui/material'
import type { SimulationInput } from '../../api/types'
import DecimalInput from './DecimalInput'

export default function ProjectInfoCard({
  form,
  setForm,
}: {
  form: SimulationInput
  setForm: React.Dispatch<React.SetStateAction<SimulationInput>>
}) {
  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr 1fr' },
          }}
        >
          <TextField
            label="Nom du projet"
            size="medium"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            required
          />
          <TextField
            size="medium"
            label="Adresse du projet"
            value={form.address}
            onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))}
          />
          <DecimalInput
            label="Surface du projet"
            unit="m²"
            value={form.surface}
            onChange={(surface) => setForm((f) => ({ ...f, surface }))}
            required
          />
        </Box>
      </CardContent>
    </Card>
  )
}
